import useCustomer from '@/hooks/user/useCustomer';
import { ProductLineItem } from './ProductLineItem';
import { OrderDetails, ProductList, ProductListItem } from './Styles';
import type { Product } from './types';

export type OrderSummaryProps = {
  products: Product[];
};

export function OrderProductsSummary({ products }: OrderSummaryProps) {
  const { data: customer } = useCustomer();

  if (products.length === 0) {
    return null;
  }

  return (
    <OrderDetails>
      <ProductList role="list">
        {products.map((product) => (
          <ProductListItem key={product.id}>
            <ProductLineItem
              label={product.name}
              amount={product.formattedTotalPrice}
              quantity={product.quantity}
              supplier={product.supplier}
              isConcession={Boolean(product.isConcession && customer?.isConcession)}
              discount={product.discount}
            />
          </ProductListItem>
        ))}
      </ProductList>
    </OrderDetails>
  );
}

export default OrderProductsSummary;
